module.exports = __webpack_public_path__ + "b9f20467d2c0de4e5d32f0d809b46e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personal/message.png
// module id = 300
// module chunks = 0